import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  ListGroup,
  Image,
  Button,
  Spinner,
} from "react-bootstrap";
import IMAGES from "../constants/images";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import RatingStars from "./RatingStars";
import ReactShowMoreText from "react-show-more-text";
import { toast } from "react-toastify";
import { deleteProduct, fetchCategoryProducts } from "api/ProductService";
import CommonModal from "./CommonModal";
import { Sentry } from "react-activity";
import { stripHtmlTags } from "utils/helpers";
import Loader from "./Loader";

// import PaginatedList from "./PaginatedList";

// const productsData = {
//   "Project Management": [
//     {
//       name: "monday Work Management",
//       reviews: 2306,
//       rating: 4.5,
//       image: IMAGES.Logo1,
//       bgColor: "#FFDDE2",
//     },
//     {
//       name: "Smartsheet",
//       reviews: 4026,
//       rating: 4.5,
//       image: IMAGES.Logo2,
//       bgColor: "#D4EBFF",
//     },
//     {
//       name: "Notion",
//       reviews: 2536,
//       rating: 4.5,
//       image: IMAGES.Logo3,
//       bgColor: "#E6DFFF",
//     },
//     {
//       name: "Asana",
//       reviews: 3026,
//       rating: 4.5,
//       image: IMAGES.Logo4,
//       bgColor: "#FFDDE2",
//     },
//     {
//       name: "Slack",
//       reviews: 6524,
//       rating: 4.5,
//       image: IMAGES.Logo5,
//       bgColor: "#DEFCF8",
//     },
//     {
//       name: "Airtable",
//       reviews: 6523,
//       rating: 4.5,
//       image: IMAGES.Logo6,
//       bgColor: "#FFF7D7",
//     },
//     {
//       name: "Trello",
//       reviews: 8452,
//       rating: 4.5,
//       image: IMAGES.Logo7,
//       bgColor: "#C9EBFF",
//     },
//     {
//       name: "ClickUp",
//       reviews: 5620,
//       rating: 4.5,
//       image: IMAGES.Logo8,
//       bgColor: "#FFDCE5",
//     },
//   ],
// };

const ProductComponent = ({ userId }) => {
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async ({ userId }) => {
    try {
      setLoading(true);

      const res = await fetchCategoryProducts({ userId, page });
      if (res.success) {
        // setProducts(res.body.data);
        setProducts((prev) =>
          page === 1 ? res.body.data : [...prev, ...res.body.data]
        );
        setTotalPages(res.body.total_pages);
        // scrollToProductList();
      }
    } catch (err) {
      console.error("Error loading products", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userId) fetchProducts({ userId });
  }, [userId, page]);

  const loadMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchProducts(nextPage);
  };
  // const [selectedCategory] = useState("Project Management");
  // const products = productsData[selectedCategory];
  const [showModal2, setShowModal2] = useState({ data: null, value: false });

  const handleCloseModal2 = () => {
    setShowModal2({ data: null, value: false });
  };

  const handleDelete = async () => {
    try {
      setDeleteLoader(true);
      if (!showModal2.data) {
        return;
      }
      const res = await deleteProduct({ id: showModal2.data });
      if (res.success) {
        toast.success(res.message);
        handleCloseModal2();
        setPage(1)
        fetchProducts(userId);
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.error("Delete Error:", err);
      toast.error("Something went wrong while deleting the product.");
    } finally {
      setDeleteLoader(false);
    }
  };
  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center "
        style={{ minHeight: "50vh" }}
      >
        <Sentry color="#e91515" size={40} speed={1} animating={true} />
        {/* <Loader  style={{width: 100, height: 100}} /> */}
      </div>
    );
  return (
    <div>
      <Row className="categories_section categories_section1 categories_section2 ">
        {products.length > 0 ? products?.map((product, index) => (
          <Col
            lg={6}
            xl={6}
            md={12}
            sm={12}
            key={index}
            className=" d-flex "
            style={{ marginBottom: "50px" }}
          >
            <Card className="w-100 h-100" style={{border:userId && "1px solid #b9b9b9"}}>
              <Card.Body className="d-flex flex-column">
                <div className="comparepos">
                  <Link
                    className="me-2"
                    to={`/vendor/editproduct`}
                    state={{ slug: product?.slug }}
                  >
                    <Image src={IMAGES.Edit_IMG} />
                  </Link>
                  <Link
                    onClick={() =>
                      setShowModal2({ data: product?._id, value: true })
                    }
                  >
                    <Image src={IMAGES.Delete_IMG} />
                  </Link>
                </div>
                <Link
                  to={`/product-details/${product?.slug}`}
                  className="iconBox"
                  style={{
                    backgroundColor: product?.brandColors || "#ffffff",
                  }}
                >
                  {/* <img
                    src={product.image}
                    alt={product.name}
                    style={{ width: 50, height: 50 }} */}
                  <img
                    src={product?.logoUrl}
                    alt={product?.name}
                    style={{ width: 48, height: 48,objectFit:"contain" }}
                  />
                </Link>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div>
                    <Link
                      to={`/product-details/${product?.slug}`}
                      className="text-decoration-none text-dark hoverAnchorColor"
                    >
                      <Card.Title className="mb-0">{product?.name}</Card.Title>
                    </Link>
                    <Card.Text className="mb-0 d-flex align-items-center">
                      <RatingStars rating={product?.avgRating} />
                      <div
                        className="total_review_text"
                        style={{ marginLeft: "4px" }}
                      >
                        ({product?.totalReviews}) {product?.avgRating || 0}{" "}
                        <span>out of</span> 5
                      </div>
                    </Card.Text>
                  </div>
                </div>
                <Card.Title className="mb-2">Product Description</Card.Title>
                {/* <p className="para"> */}
                <Card.Text className="para truncate-2-lines" >
  
      {/* <ReactShowMoreText
        lines={2}
        more="See more"
        less="See less" 
        anchorClass="see-more-link"
        expanded={false}    
        width={0}
      > */}
        {stripHtmlTags(product?.description)}
      {/* </ReactShowMoreText> */}
  
</Card.Text>

                <Card.Title className="mb-2 font14 fw-bold">
                  Other Info
                </Card.Title>
                <ListGroup className="customListGroup">
                 {product?.whoCanUse.length  > 0 && <ListGroup.Item>
                    <Icon icon="tabler:users" fontSize={24} />
                    <span>
                      <strong>Users</strong> ({product?.whoCanUse
                            .map((item) => item?.title)
                            .join(", ")}
                          )
                    </span>
                  </ListGroup.Item>}
                 {product?.industries.length>0 && <ListGroup.Item>
                    <Icon icon="clarity:building-line" fontSize={24} />
                    <span>
                      <strong>Industries</strong> ({product?.industries
                            .map((item) => item?.title)
                            .join(", ")})
                    </span>
                  </ListGroup.Item>}
                {product?.marketSegment.length>0 &&  <ListGroup.Item>
                    <Icon icon="ph:line-segments" fontSize={24} />
                    <span>
                      <strong>Users</strong> 
                      {/* (63% Small-Business, 29%
                      Mid-Market) */}
                      ({product?.marketSegment
                            .map((item) => item?.title)
                            .join(", ")})
                    </span>
                  </ListGroup.Item>}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        )):<Col xs={12}>
        <div className="text-center py-5">
          <Image
            src={IMAGES.emptyState}
            alt=""
              height="300px"
            width= "300px"
            className="mb-4"
            // className="imgUser"
          />
       <p className="text-center text-muted">No products found.</p>
       </div>
       </Col>}
      </Row>

      {page < totalPages && (
                      <div className="text-center mt-3  d-flex justify-content-center">
                        <Button
                          variant="outline-primary"
                          onClick={loadMore}
                          disabled={loading}
                          style={{
                            width: "351px",
                            borderRadius: "50px",
                            borderColor: "#0071E3",
                            color: "#0071E3",
                          }}
                        >
                          {loading ? (
                            <Spinner animation="border" size="sm" />
                          ) : (
                            "More Reviews"
                          )}
                        </Button>
                      </div>
                    )}
      {/* <PaginatedList totalItems={30} itemsPerPage={10} /> */}

      <CommonModal
        title={"Delete Product?"}
        para={"Are you sure, You want to delete this product?"}
        body={
          <div className="btn_Flex">
            <Button
              onClick={handleCloseModal2}
              variant="outline-info"
              className="border-radius-100"
            >
              Cancel
            </Button>
            <Button
              disabled={deleteLoader}
              onClick={handleDelete}
              variant="info"
              className="border-radius-100"
            >
              {deleteLoader ? (
                <Spinner animation="border" size="sm" />
              ) : (
                "Yes I'm Sure"
              )}
            </Button>
          </div>
        }
        show={showModal2.value}
        onClose={handleCloseModal2}
      />
    </div>
  );
};

export default ProductComponent;
